import { useSyncExternalStore } from "react";
import hindi from "@/locales/hi.json";

export const LANGUAGE_KEY = "vanshvriksham_language";
const LEGACY_LANGUAGE_KEY = "vansvriksh_language";
const listeners = new Set();
const validLanguage = (value) => value === "hi" ? "hi" : "en";
function savedLanguage() {
  try {
    const saved = window.localStorage.getItem(LANGUAGE_KEY);
    if (saved !== null) return validLanguage(saved);
    const legacy = window.localStorage.getItem(LEGACY_LANGUAGE_KEY);
    if (legacy !== null) window.localStorage.setItem(LANGUAGE_KEY, validLanguage(legacy));
    return validLanguage(legacy);
  }
  catch { return "en"; }
}
function initialLanguage() {
  if (typeof window === "undefined") return "en";
  const path = window.location.pathname.replace(/\/+$/, "") || "/";
  if (["/hi", "/hi/about", "/hi/contact", "/hi/privacy-policy"].includes(path)) return "hi";
  if (["/", "/about", "/contact", "/privacy-policy"].includes(path)) return "en";
  return savedLanguage();
}
let language = initialLanguage();
export const getLanguage = () => language;
const subscribe = (listener) => { listeners.add(listener); return () => listeners.delete(listener); };
export const useLanguage = () => useSyncExternalStore(subscribe, getLanguage, getLanguage);

function updateDocument() {
  if (typeof document === "undefined") return;
  document.documentElement.lang = language;

}
export function setLanguage(value) {
  language = validLanguage(value);
  try { window.localStorage.setItem(LANGUAGE_KEY, language); } catch { /* Available even when storage is disabled. */ }
  updateDocument();
  listeners.forEach((listener) => listener());
}
if (typeof window !== "undefined") {
  updateDocument();
  window.addEventListener("storage", (event) => {
    if (event.key === LANGUAGE_KEY || event.key === LEGACY_LANGUAGE_KEY || event.key === null) {
      language = initialLanguage(); updateDocument(); listeners.forEach((listener) => listener());
    }
  });
}

// English UI text is the key and fallback. Interpolation keeps personal data
// out of the dictionary and never changes submitted values.
export function t(text, values = {}) {
  if (typeof text !== "string") return text;
  const key = text.trim();
  const translated = language === "hi" ? hindi[key] || key : key;
  const result = translated.replace(/\{(\w+)\}/g, (match, name) => Object.prototype.hasOwnProperty.call(values, name) ? String(values[name] ?? "") : match);
  return (text.match(/^\s*/)?.[0] || "") + result + (text.match(/\s*$/)?.[0] || "");
}

export const locale = () => language === "hi" ? "hi-IN" : "en-IN";

export function countryName(name, code) {
  if (language !== "hi" || !code || typeof Intl.DisplayNames !== "function") return name;
  try { return new Intl.DisplayNames(["hi"], { type: "region" }).of(code) || name; }
  catch { return name; }
}
